module.exports = __webpack_public_path__ + "static/media/test8_3.fdf2ce81.png";